export enum EInvoiceCreationValidationCode {
    DocumentHeaderNotFound = 'DocumentHeaderNotFound',
    XmlNotFound = 'XmlNotFound',
    NoXmlYet = 'NoXmlYet',
    DocumentAlreadyExists = 'DocumentAlreadyExists',
    InvalidXml = 'InvalidXml',
    Unexpected = 'Unexpected',
}

export enum EInvoiceCreationValidationErrorCode {
    UnsupportedSchema = 'UnsupportedSchema',
    UnsupportedDocumentKind = 'UnsupportedDocumentKind',
    NoCurrencyInDictionary = 'NoCurrencyInDictionary',
    NoCurrencyExchangeRate = 'NoCurrencyExchangeRate',
    DifferentExchangeRates = 'DifferentExchangeRates',
    InvalidSellerCountryCode = 'InvalidSellerCountryCode',
    UnsupportedCommunityTransaction = 'UnsupportedCommunityTransaction',
    InvoiceOSS = 'InvoiceOSS',
    UnsupportedVatRates = 'UnsupportedVatRates'
}
